import { SearchesService } from '../services'

export default (fromNum, resultsPerPage, filters = null, userId) => {
  return SearchesService.read(fromNum, resultsPerPage, filters, userId)
    .then((response) => {
      if (!response) {
        const error = new Error('HTTP_ERROR')
        error.response = response
        return Promise.reject(error)
      }

      return response.data
    })
    .catch((error) => Promise.reject(error))
}
